"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const mediaQuery_enum_1 = require("../../core/mediaQuery.enum");
exports.FormWrapper = styled_components_1.default.div `
  @media (min-width: ${mediaQuery_enum_1.MediaQuery.MEDIUM}px) {
    width: 50%;
  }
`;
